<template>
    <div id="InformationCenter">
    <view1/>
    <view2/>

    </div>

</template>
<script>
    export default {
        name: 'InformationCenter',
        components: {
            // 异步加载子组件
            view1: () => import('@/views/InformationCenter/view1.vue'),
            view2: () => import('@/views/InformationCenter/view2.vue')
        }
    }
</script>
<style scoped>
</style>